import angular from 'angular';
import { ssListItem } from 'app/components/global';
import processRecoveryFunction from '../processRecoveryFunction';
import directive from './process-recovery.directive';


export default angular.module('app.components.advisory.bcp.processRecovery', [
  ssListItem,
  processRecoveryFunction,
])
  .directive('bcpProcessRecovery', directive)
  .controller('ProcessRecoveryController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.bcp.processRecovery created');
